import React, { Component } from 'react';
import Card from '../../Components/Card/bigCard';
import { Link, Redirect } from 'react-router-dom';
// Components
import Ticket from '../../Components/Ticket/ticketConfirm'
import TicketTotal from '../../Components/Ticket/ticketTotal'
import AzulBtn from '../../static/images/pagarazul.png'
import CreditCard from '../../static/images/creditcards.png'
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import Cookies from 'universal-cookie';
import axios from 'axios';
import Countdown from 'react-countdown-now';
const cookies = new Cookies();


const getState = (state) => {
    console.log(state.CurrentSeat)
    return {
        currentEvent: state.currentEvent,
        url: state.url,
    }
}

const Dispatch = (dispatch) => {
    return {}
}
class Checkout extends Component {
    constructor() {
        super()
        this.state = {
            seats: [],
            TotalPaid: 0,
            MerchantId: '',
            MerchantName: '',
            MerchantType: '',
            CurrencyCode: '',
            OrderNumber: '',
            Amount: '',
            ITBIS: 0,
            ApprovedUrl: '',
            DeclinedUrl: '',
            CancelUrl: '',
            UseCustomField1: '',
            CustomField1Label: '',
            CustomField1Value: '',
            UseCustomField2: '',
            AuthHash: '',
            hash: '',
            countdown:'',
        }
    }

    hash = () => {
        let url = this.props.url
        let data = {
            Amount: this.state.TotalPaid * 100,
            ITBIS: parseInt((this.state.TotalPaid * 0.18) * 100),
            user: cookies.get('key'),
            event: this.props.currentEvent,
        }
        axios.post(url + '/api/v1/core/hash/', data)
            .then(response => {
                console.log(response.data)
                this.setState({
                    MerchantId: response.data.MerchantId,
                    MerchantName: response.data.MerchantName,
                    MerchantType: response.data.MerchantType,
                    CurrencyCode: response.data.CurrencyCode,
                    OrderNumber: response.data.OrderNumber,
                    Amount: response.data.Amount,
                    ITBIS: response.data.ITBIS,
                    ApprovedUrl: response.data.ApprovedUrl,
                    DeclinedUrl: response.data.DeclinedUrl,
                    CancelUrl: response.data.CancelUrl,
                    UseCustomField1: response.data.UseCustomField1,
                    CustomField1Label: response.data.CustomField1Label,
                    CustomField1Value: response.data.CustomField1Value,
                    UseCustomField2: response.data.UseCustomField2,
                    AuthKey: response.data.AuthKey,
                    AuthHash: response.data.hash,
                }, () => {
                    document.getElementById('form-azul').submit();
                })
                // document.getElementById("form").submit()
            })
            .catch(err => {
                console.log(err)
            })
    }

    getDataHas = () => {
        let url = this.props.url
        let data = {
            Amount: this.state.TotalPaid * 100,
            ITBIS: parseInt((this.state.TotalPaid * 0.18) * 100),
        }
        this.setState({ Amount: parseInt(data.Amount), ITBIS: parseInt(data.ITBIS) })
        console.log(data)
        axios.post(url + "/api/v1/core/hash/", data)
            .then(response => {
                console.log(response.data)
                this.setState({
                    Amount: response.data.Amount,
                    ApprovedUrl: response.data.ApprovedUrl,
                    AuthKey: response.data.AuthKey,
                    CancelUrl: response.data.CancelUrl,
                    CurrencyCode: response.data.CurrencyCode,
                    CustomField1Label: response.data.CustomField1Label,
                    CustomField1Value: response.data.CustomField1Value,
                    CustomField2Label: response.data.CustomField2Label,
                    CustomField2Value: response.data.CustomField2Value,
                    DeclinedUrl: response.data.DeclinedUrl,
                    // ITBIS: parseInt(response.data.ITBIS),
                    MerchantId: response.data.MerchantId,
                    MerchantName: response.data.MerchantName,
                    MerchantType: response.data.MerchantType,
                    OrderNumber: response.data.OrderNumber,
                    ResponsePostUrl: response.data.ResponsePostUrl,
                    UseCustomField1: response.data.UseCustomField1,
                    UseCustomField2: response.data.UseCustomField2,
                    hash: response.data.hash
                }, function () {
                    setTimeout(() => {
                        console.log(this.state)
                        document.getElementById('form-azul').submit();
                    }, 2000);
                })
            })
            .catch(err => {
                console.log(err)
            })
    }

    componentWillMount = () => {
        var today = new Date();
        let url = this.props.url;
        axios.get(url + "/api/v1/cart/get/" + cookies.get('key') + "/?data=" + this.props.currentEvent.id)
            .then(response => {
                let total = 0
                for (let x = 0; x < response.data.length; x++) {
                    if (response.data[x].invited) {
                        total = total + parseInt(response.data[x].ticket_price_invited)
                    } else {
                        total = total + parseInt(response.data[x].ticket_price_partner)
                    }
                }
                let date = new Date(response.data[0].timestamp)
                console.log(today, date, today - date)
                this.setState({ countdown: today - date, seats: response.data, TotalPaid: total })
            }, console.log(this.state.countdown))
            .catch(err => {
                console.log(err)
            })
    }
    componentDidMount = () => {
        if (document.getElementById('description-content') !== null) {
            document.getElementById('description-content').innerHTML = this.props.currentEvent.description;
        }
    }

    changeInvited = (e) => {
        let url = this.props.url
        let val = e.target.checked
        let seats = this.state.seats
        let key = e.target.getAttribute('data-index')
        seats[key].invited = val
        this.setState({ seats })
        axios.put(url + "/api/v1/cart/update/" + seats[key].id + "/", seats[key])
            .then(response => {
                // console.log(response.data)
            })
            .catch(err => {
                console.log(err)
            })
        let total = 0
        for (let x = 0; x < seats.length; x++) {
            if (seats[x].invited) {
                total = total + parseInt(seats[x].ticket_price_invited)
            } else {
                total = total + parseInt(seats[x].ticket_price_partner)
            }
        }
        this.setState({ TotalPaid: total })
    }
    deleteSeatCart = (key) => {
        let url = this.props.url

        // let key = e.target.getAttribute('data-index')
        let seats = this.state.seats
        let total = this.state.TotalPaid
        if (seats[key].invited) {
            total = parseInt(total) - parseInt(seats[key].ticket_price_invited)
        } else {
            total = parseInt(total) - parseInt(seats[key].ticket_price_partner)
        }
        let data = {
            status: 'Disponible',
        }
        if (seats[key].type_seat === 'sub') {
            axios.put(url + "/api/v1/reservations/availability/sub/available/" + seats[key].id_availability + "/", data)
        } else {
            axios.put(url + "/api/v1/reservations/availability/" + seats[key].id_availability + "/available/", data)
        }
        axios.delete(url + "/api/v1/cart/delete/" + seats[key].id + "/")
            .then(response => {
                axios.get(url + "/api/v1/cart/get/" + cookies.get('key') + "/?data=" + this.props.currentEvent.id).then(response => { this.setState({ seats: response.data, TotalPaid: total }) })
            })
    }

    rendererCountdown = ({ hours, minutes, seconds, completed }) => {
      
            return <span>{minutes}:{seconds}</span>;

    };
    render() {
        if (typeof this.props.currentEvent.name === 'undefined') {
            return <Redirect to={'/'} />
        }
        return (
            <div className="container pt-6">
                <Card>
                    <div className="d-inline back">
                        <Link to={'/detail/' + this.props.currentEvent.name} className="back-btn"><i className="fa fa-caret-left"></i> Atrás</Link>
                        <span className='countdown'>Tiempo Restante:<Countdown date={Date.now() + (900000 - this.state.countdown)} renderer={this.rendererCountdown}/></span>
                    </div>
                    
                    <div className="row pt-6">
                        <div className="offset-sm-1 col-sm-10 text-center">
                            <h2>Shakira "El Dorado" World Tour 2018</h2>
                            <p className="paragraph text-justify" id='description-content'>{/*Descripcion del evento*/}</p>
                            <h5 className="title-green strong pt-4">Confirme sus asientos</h5>
                            <div className="map-container pt-6">
                                <div className="row">
                                    <div className="col-8 offset-2">
                                        {this.state.seats.map((el, key) => {
                                            let price = 0;
                                            if (el.invited) {
                                                price = <NumberFormat thousandSeparator={true} displayType={'text'} value={el.ticket_price_invited} />
                                            } else {
                                                price = <NumberFormat thousandSeparator={true} displayType={'text'} value={el.ticket_price_partner} />
                                            }
                                            return <Ticket key={key}
                                                ticketName={"Sección " + el.ticket_name.name}
                                                deleteSeatCart={this.deleteSeatCart}
                                                seat={el.name_seat}
                                                price={price}
                                                invited={el.invited}
                                                dataIndex={key}
                                                changeInvited={this.changeInvited} />
                                        })
                                        }
                                    </div>
                                </div>
                                <div className="pt-6">
                                    <span className="total">Total a Pagar </span><br />
                                    <TicketTotal price={<NumberFormat thousandSeparator={true} displayType={'text'} value={this.state.TotalPaid} />} />
                                </div>
                                <div className="text-center pt-8 pb-6">
                                    <form id='form-azul' action="https://pruebas.azul.com.do/paymentpage/" method="post">
                                        <input type="hidden" id="MerchantId" name="MerchantId" value={this.state.MerchantId} />
                                        <input type="hidden" id="MerchantName" name="MerchantName" value={this.state.MerchantName} />
                                        <input type="hidden" id="MerchantType" name="MerchantType" value={this.state.MerchantType} />
                                        <input type="hidden" id="CurrencyCode" name="CurrencyCode" value={this.state.CurrencyCode} />
                                        <input type="hidden" id="OrderNumber" name="OrderNumber" value={this.state.OrderNumber} />
                                        <input type="hidden" id="Amount" name="Amount" value={this.state.Amount} />
                                        <input type="hidden" id="ITBIS" name="ITBIS" value={this.state.ITBIS} />
                                        <input type="hidden" id="ApprovedUrl" name="ApprovedUrl" value={this.state.ApprovedUrl} />
                                        <input type="hidden" id="DeclinedUrl" name="DeclinedUrl" value={this.state.DeclinedUrl} />
                                        <input type="hidden" id="CancelUrl" name="CancelUrl" value={this.state.CancelUrl} />
                                        <input type="hidden" id="UseCustomField1" name="UseCustomField1" value={this.state.UseCustomField1} />
                                        <input type="hidden" id="CustomField1Label" name="CustomField1Label" value={this.state.CustomField1Label} />
                                        <input type="hidden" id="CustomField1Value" name="CustomField1Value" value={this.state.CustomField1Value} />
                                        <input type="hidden" id="UseCustomField2" name="UseCustomField2" value={this.state.UseCustomField2} />
                                        <input type="hidden" id="AuthHash" name="AuthHash" value={this.state.AuthHash} />
                                    </form>
                                    <img src={AzulBtn} onClick={this.hash} className="payment-azul d-block" />
                                    <img src={CreditCard} className="payment-creditcard d-block" />
                                </div>
                            </div>
                        </div>
                    </div>

                </Card>
            </div>
        );
    }
}

export default connect(getState, Dispatch)(Checkout);





// WEBPACK FOOTER //
// ./src/Pages/Checkout/index.js